// ui
export const TOGGLE_REGISTER_DIALOG = "TOGGLE_REGISTER_DIALOG";
export const TOGGLE_PRODUCT_DETAILS = "TOGGLE_PRODUCT_DETAILS";
export const TOGGLE_LOADING = "TOGGLE_LOADING";
export const TOGGLE_CART = "TOGGLE_CART";
export const SET_SCROLL_POSITION = "SET_SCROLL_POSITION";
export const CHANGE_TOOLBAR_THEME = "CHANGE_TOOLBAR_THEME";
export const SET_WINDOW_SIZE = "SET_WINDOW_SIZE";
//
export const ADD_STORE = "ADD_STORE";
export const ADD_PRODUCT_DETAILS = "ADD_PRODUCT_DETAILS";
export const ADD_CART = "ADD_CART";
export const UPDATE_MESSAGE_COUNT = "UPDATE_MESSAGE_COUNT";
export const REMOVE_CART_FROM_STORE = "REMOVE_CART_FROM_STORE";
// auth
export const LOGIN = "LOGIN";
export const AUTO_LOGIN = "AUTO_LOGIN";
export const SET_IS_AUTH = "SET_IS_AUTH";
export const LOGOUT = "LOGOUT";
export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_CART = "UPDATE_CART";
export const UPDATE_USER_AND_CART = "UPDATE_USER_AND_CART";
